import * as MetricsPageConstants from './MetricpageConstants';
import { produce } from "immer";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isMetricsListViewDataCalled: false,
    isMetricsListViewDataFetched: false,
    isMetricsListViewDataCancelled: false,
    isMetricsListViewDataCallFailed: false,
    isMetricsFilterNoSelected: false,
    actionMessage: "",
    metricsListView: [],
    statCounts: {
        connectivity: undefined,
        availability: undefined,
        critical: undefined,
        warning: undefined,
        patientTotalTest: undefined
    },
    filters: {
        data: [],
        incident: [
            { label: "(Blank)", value: "(Blank)" },
            { label: "Critical", value: "Critical" },
            { label: "Warning", value: "Warning" },
            { label: "Error", value: "Error" },
            { label: "Fail", value: "Fail" },
        ],
        model: [],
        city: [],
        country: [],
        customer: [],
        isLoaded: false,
    },
    selectedFilters: {
        incident: [],
        model: [],
        city: [],
        country: [],
        customer: [],
        serialNumber: "",
        toDate: undefined,
        fromDate: undefined
    },
    errorMessage: "",
    statCardText: ""
}

export default function MetricsPageReducer(state = initialState, action) {

    switch (action.type) {
        case MetricsPageConstants.LOAD_METRICS_FILTER_REQUEST: {
            return assign({}, state, {
                ...state,
                filters: {
                    ...initialState.filters,
                    isLoaded: false
                }
            });
        }
        case MetricsPageConstants.LOAD_METRICS_FILTER_SUCCESS: {
            return assign({}, state, {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload,
                    isLoaded: true
                }
            });
        }
        case MetricsPageConstants.CHANGE_FILTER_VALUE: {
            const newState = produce(state, draft => {
                draft.selectedFilters[action.payload.key] = action.payload.value;
            });
            return assign({}, state, newState);
        }
        case MetricsPageConstants.SET_ERROR_MESSAGE: {
            return assign({}, state, {
                ...state,
                errorMessage: action.payload
            });
        }
        case MetricsPageConstants.SET_STAT_CARD_TEXT: {
            return assign({}, state, {
                ...state,
                statCardText: action.payload
            });
        }
        case MetricsPageConstants.SET_STAT_COUNT: {
            const newState = produce(state, draft => {
                draft.statCounts[action.payload.key] = action.payload.value;
            });
            return assign({}, state, newState);
        }

        case MetricsPageConstants.LOAD_METRICS_LIST_VIEW:
            return assign({}, state, {
                isMetricsListViewDataCalled: true,
                isMetricsListViewDataFetched: false,
                isMetricsListViewDataCancelled: false,
                isMetricsListViewDataCallFailed: false,
                isMetricsFilterNoSelected: false,
                actionMessage: "Status : In Progress",
                metricsListView: []
            });
            break;
        case MetricsPageConstants.LOAD_METRICS_LIST_VIEW_SUCCESS:
            return assign({}, state, {
                isMetricsListViewDataCalled: false,
                isMetricsListViewDataFetched: true,
                isMetricsListViewDataCancelled: false,
                actionMessage: "",
                metricsListView: action.newState.metricsListView
            });
            break;
        case MetricsPageConstants.LOAD_METRICS_LIST_VIEW_CANCELLED:
            return assign({}, state, {
                isMetricsListViewDataCalled: false,
                isMetricsListViewDataFetched: false,
                isMetricsListViewDataCancelled: true,
                actionMessage: "Status : Cancelled",
                metricsListView: []
            });
            break;
        case MetricsPageConstants.ERROR_LOAD_METRICS_LIST_VIEW:
            return assign({}, state, {
                isMetricsListViewDataCalled: false,
                isMetricsListViewDataCallFailed: true,
                actionMessage: "",
                metricsListView: []
            });
            break;
        case MetricsPageConstants.ERROR_FILTERS_NOT_SELECTED:
            return assign({}, state, {
                isMetricsListViewDataFetched: false,
                isMetricsFilterNoSelected: true,
                actionMessage: "",
                metricsListView: []
            });
            break;
        default:
            return state;

    }

}
